<div mat-dialog-title fxLayout="column" fxLayoutAlign="space-between flex-start">
    <div fxLayout="row" fxLayoutAlign="space-between top" class="fullwidth">
        @if (!project.tandemMode) {
            @if (!(project && project.maxBadgeGrantee > 1)) {
                <div>
                    {{ "bagde_editor.give_badge" | translate }}
                </div>
            }
            @if (project && project.maxBadgeGrantee > 1) {
                <mat-tab-group (selectedTabChange)="onTabChanged($event)">
                    <mat-tab label="Individual"></mat-tab>
                    <mat-tab label="Grupal"></mat-tab>
                </mat-tab-group>
            }
        }

        @if (project.tandemMode) {
            <div fxLayout="column" class="gap-1">
                <h3>{{ "bagde_editor.give_badge" | translate }}</h3>
                <mat-tab-group (selectedTabChange)="onTabChanged({ index: $event.index + 2 })">
                    <!-- Para no modificar el resto del código. Tabs 2, 3 y 4 -->
                    @if (project.id == 473) {
                        <mat-tab label="TËCNICOS"></mat-tab>
                        <mat-tab label="TEC / DIRECTOR"></mat-tab>
                        <mat-tab label="ETIs"></mat-tab>
                    } @else {
                        <mat-tab label="Alumnos"></mat-tab>
                        <mat-tab label="Formadores"></mat-tab>
                        <mat-tab label="ETIs"></mat-tab>
                    }
                </mat-tab-group>
            </div>
        }

        <button mat-icon-button mat-dialog-close style="color: #666">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    @if (!project.tandemMode) {
        <div class="fullwidth" style="position: relative; margin-top: 5px">
            <mat-form-field subscriptSizing="dynamic" class="search-user w-100-p">
                <input
                    matInput
                    placeholder="{{ 'badge_editor.search_people_placeholder' | translate }}"
                    [(ngModel)]="filterPersonValue"
                    (keyup)="filterPersons($event)"
                />
                @if (!personSelected) {
                    <mat-icon matSuffix class="s-18">search</mat-icon>
                }
                @if (filterPersonValue.length > 0) {
                    <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="clearPerson()">
                        <mat-icon>close</mat-icon>
                    </button>
                }
            </mat-form-field>
            @if (persons.length > 0 && !personSelected) {
                <div class="wrap-persons">
                    <div class="list-persons">
                        @for (person of persons; track person) {
                            <div
                                fxlayout="row"
                                fxLayoutAlign="flex-start center"
                                class="item-person"
                                (click)="selectPerson(person)"
                            >
                                <div class="person-avatar avatar-50 mr-8" fxLayout="row" fxLayoutAlign="center center">
                                    <img
                                        class="img-circle"
                                        [src]="getImagePerson(person.username)"
                                        [title]="person.username"
                                    />
                                </div>
                                <div fxLayout="column" class="info-person">
                                    <span class="m-0 font-size-14">{{ "@" + person.username }}</span>
                                    <span class="m-0 font-size-14"
                                        ><strong>{{ person.displayName }}</strong></span
                                    >
                                </div>
                            </div>
                        }
                    </div>
                </div>
            }
        </div>
    }
</div>

<!-- ############## BADGE INDIVIDUAL ############# -->
@if (badgeTab == 0) {
    <mat-dialog-content class="mat-typography">
        <!-- <span>Badge RETURN {{badgeReturn}}</span> -->
        @if (!personSelected) {
            <div>
                <p class="m-0 mb-8">
                    <b>{{ "bagde_editor.other_user" | translate }}</b>
                </p>
                <div fxLayout="row wrap">
                    @for (person of personsSuggestion; track person) {
                        <div
                            fxFlex="50"
                            fxlayout="row"
                            fxLayoutAlign="flex-start center"
                            class="btn-select-person p-12"
                            (click)="selectPerson(person)"
                        >
                            @if (person) {
                                <div class="person-avatar avatar-50 mr-8" fxLayout="row" fxLayoutAlign="center center">
                                    <img
                                        class="img-circle"
                                        [src]="getImagePerson(person.username)"
                                        [title]="person.username"
                                    />
                                </div>
                            }
                            @if (person) {
                                <div fxLayout="column" class="info-person">
                                    <h4 class="m-0 font-size-18 text-theme">{{ person.displayName }}</h4>
                                    <small class="m-0 font-size-12">{{ getPuesto(person) }}</small>
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        @if (personSelected) {
            <div>
                <div class="badge-responsive-container" fxLayout="row">
                    <div
                        fxLayout="column"
                        fxLayoutAlign="flex-start center"
                        class="pr-20"
                        style="width: 32%; min-width: 140px"
                    >
                        <div class="person-avatar avatar-132" fxLayout="row" fxLayoutAlign="center center">
                            <img
                                class="img-circle"
                                [src]="getImagePersonGrande(personSelected.username)"
                                [title]="personSelected.username"
                            />
                            @if (competencySelected && competencySelected.type_competency === 0) {
                                <img
                                    class="badge-selected animated zoomIn"
                                    [src]="getImageCompetency(competencySelected.id)"
                                    [title]="competencySelected.name"
                                />
                            }
                            @if (competencySelected && competencySelected.type_competency !== 0) {
                                <img
                                    class="badge-selected animated zoomIn"
                                    [src]="getImageDefaultMission()"
                                    [title]="competencySelected.name"
                                />
                            }
                        </div>
                        @if (project.badge_type) {
                            <div>
                                <h5 class="m-0 mb-8 mt-12 title-card-gray text-theme text-center">
                                    <b>{{ "bagde_editor.mission" | translate }}</b>
                                </h5>
                                <p class="m-0 font-size-14 text-center">{{ getMision(personSelected) }}</p>
                                @if (competencySelected) {
                                    <h5 class="m-0 mb-8 mt-12 title-card-gray text-theme text-center">
                                        <b>Selección</b>
                                    </h5>
                                    <p class="m-0 font-size-14 text-center">{{ competencySelected.name }}</p>
                                }
                            </div>
                        }
                    </div>
                    <div fxFlex="1 1 0" fxLayout="row" class="pl-20">
                        @if (badgeStep === 1 && !project.badge_type) {
                            <div class="competency-main" fxLayout="column">
                                <span class="m-0 font-size-14">{{
                                    "badge_editor.mission.value.title2" | translate
                                }}</span>
                                <div
                                    fxLayout="row wrap"
                                    fxLayoutAlign="space-around center"
                                    class="competency-list mt-8 px-20"
                                >
                                    @for (competency of competencies.valores; track competency) {
                                        <div
                                            fxFlex="1 0 auto"
                                            fxLayoutAlign="center center"
                                            class="animated zoomIn"
                                            [title]="competency.name"
                                            (click)="selectCompetency(competency)"
                                        >
                                            <img
                                                [src]="getImageCompetency(competency.id)"
                                                style="max-width: 50px; max-height: 50px"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        @if (project.badge_type) {
                            @if (badgeStep === 1) {
                                <div class="competency-main" fxLayout="column">
                                    <span class="m-0 font-size-14">{{ "badge_editor.mission.title" | translate }}</span>
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-between center"
                                        class="competency-list"
                                    >
                                        @for (competency of competencies.misionPuesto; track competency) {
                                            <div
                                                fxFlex="1 0 auto"
                                                class="mision-select mt-12 text-center animated zoomIn"
                                                [title]="competency.name"
                                                (click)="selectCompetency(competency)"
                                            >
                                                <span class="">{{ competency.name }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (competencies.misionEmpresa?.length || competencies.valores?.length) {
                                        <div class="mt-16">
                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="flex-start flex-start"
                                                style="cursor: pointer"
                                                (click)="badgeStep = 2"
                                            >
                                                <mat-icon class="s-16 mr-4 pt-4 text-theme">add_circle</mat-icon>
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.mission.other.title" | translate
                                                }}</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            @if (badgeStep === 2) {
                                <div class="competency-extra" fxLayout="column">
                                    @if (competencies.misionEmpresa?.length) {
                                        <span class="m-0 font-size-14">{{
                                            "badge_editor.mission.company.title" | translate
                                        }}</span>
                                    }
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-between center"
                                        class="competency-list"
                                    >
                                        @for (competency of competencies.misionEmpresa; track competency) {
                                            <div
                                                fxFlex="1 0 auto"
                                                class="mision-select mt-12 text-center animated zoomIn"
                                                [title]="competency.name"
                                                (click)="selectCompetency(competency)"
                                                style="max-width: 120px"
                                            >
                                                <span class="">{{ competency.name }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (competencies.valores?.length) {
                                        <span class="m-0 font-size-14 mt-16">{{
                                            "badge_editor.mission.value.title" | translate
                                        }}</span>
                                    }
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-around center"
                                        class="competency-list mt-8 px-20"
                                    >
                                        @for (competency of competencies.valores; track competency) {
                                            <div
                                                fxFlex="1 0 auto"
                                                fxLayoutAlign="center center"
                                                class="animated zoomIn"
                                                [title]="competency.name"
                                                (click)="selectCompetency(competency)"
                                            >
                                                <img
                                                    [src]="getImageCompetency(competency.id)"
                                                    style="max-width: 50px; max-height: 50px"
                                                />
                                            </div>
                                        }
                                    </div>
                                    @if (project.id != 10 && project.id != 4) {
                                        <div class="mt-12">
                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="flex-start flex-start"
                                                style="cursor: pointer"
                                                (click)="badgeStep = 1"
                                            >
                                                <mat-icon class="s-16 mr-4 pt-4 text-theme">arrow_back</mat-icon>
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.change_competency" | translate
                                                }}</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        }
                        @if (badgeStep === 3) {
                            <div fxLayout="column" class="w-100-p">
                                <div class="animated fadeInRight">
                                    <div class="mb-12">
                                        <div
                                            fxLayout="row"
                                            fxLayoutAlign="flex-start flex-start"
                                            style="cursor: pointer"
                                            (click)="badgeStep = 1; competencySelected = null; motivation = ''"
                                        >
                                            <mat-icon class="s-16 mr-4 pt-4 text-theme">arrow_back</mat-icon>
                                            @if (project.badge_type) {
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.change_competency" | translate
                                                }}</a>
                                            }
                                            @if (!project.badge_type) {
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.mission.back" | translate
                                                }}</a>
                                            }
                                        </div>
                                    </div>
                                    @if (competencySelected.type_competency === 0 || project.id == 288) {
                                        <div class="mb-16">
                                            <!-- Visible solo para comptencia de tipo Valor -->
                                            <span class="m-0 font-size-14">{{
                                                competencySelected.type_competency === 0
                                                    ? "Indicadores"
                                                    : "Comportamientos"
                                            }}</span>
                                            <div class="kpi-table">
                                                @for (indicator of indicators; track indicator) {
                                                    <div class="my-8">
                                                        <input
                                                            id="badgeIndicator{{ indicator.id }}"
                                                            type="checkbox"
                                                            [(ngModel)]="indicator.isChecked"
                                                            (change)="calNumIndicatorSelected()"
                                                        />
                                                        <label for="badgeIndicator{{ indicator.id }}">{{
                                                            indicator.name
                                                        }}</label>
                                                    </div>
                                                }
                                            </div>
                                            @if (minIndicators > 0 && minIndicators !== maxIndicators) {
                                                <span
                                                    [style]="
                                                        minIndicators > numIndicatorsSelected ||
                                                        numIndicatorsSelected > maxIndicators
                                                            ? 'visibility:visible;'
                                                            : 'visibility:hidden;'
                                                    "
                                                    class="mt-12 font-size-14"
                                                    style="color: red"
                                                    >Debe seleccionar {{ minIndicators }} o {{ maxIndicators }}
                                                    {{
                                                        competencySelected.type_competency === 0
                                                            ? "indicadores"
                                                            : "comportamientos"
                                                    }}</span
                                                >
                                            }
                                            @if (minIndicators > 0 && minIndicators === maxIndicators) {
                                                <span
                                                    [style]="
                                                        minIndicators > numIndicatorsSelected ||
                                                        numIndicatorsSelected > maxIndicators
                                                            ? 'visibility:visible;'
                                                            : 'visibility:hidden;'
                                                    "
                                                    class="mt-12 font-size-14"
                                                    style="color: red"
                                                    >Debe seleccionar únicamente {{ minIndicators }}
                                                    {{
                                                        competencySelected.type_competency === 0
                                                            ? "indicadores"
                                                            : "comportamientos"
                                                    }}</span
                                                >
                                            }
                                        </div>
                                    }
                                </div>
                                <div fxLayout="row" fxLayoutAlign="flex-start" class="w-100-p">
                                    <fb-emoji-picker
                                        position="fixed"
                                        (emojiSel)="emojiSelected($event)"
                                    ></fb-emoji-picker>
                                    <div fxLayout="column" class="w-100-p">
                                        <textarea
                                            class="form-control w-100-p"
                                            [(ngModel)]="motivation"
                                            style="height: 60px"
                                            placeholder="{{ 'badge_editor.motive.placeholder' | translate }}"
                                        ></textarea>
                                        <span
                                            [style]="
                                                motivation.length < minCharacters
                                                    ? 'visibility:visible;'
                                                    : 'visibility:hidden;'
                                            "
                                            class="text-muted"
                                            >{{ "" | translate }}Faltan {{ minCharacters - motivation.length }}
                                            {{ "" | translate }}caracteres</span
                                        >
                                    </div>
                                </div>
                                <div fxFlex="1 1 0" fxLayout="row" fxLayoutAlign="flex-end flex-end" class="mt-16">
                                    <!-- TODO:VYGON Pasar al config -->
                                    @if (project.id == 288 && competencySelected.type_competency === 1) {
                                        <button
                                            mat-button
                                            mat-dialog-close
                                            class="btn-feedbalia mr-12"
                                            [disabled]="checkValidData()"
                                            (click)="sendBadge(true)"
                                        >
                                            {{ "badge_editor.send_badge2" | translate }}
                                        </button>
                                    }
                                    <button
                                        mat-button
                                        mat-dialog-close
                                        class="btn-feedbalia"
                                        [disabled]="checkValidData()"
                                        (click)="sendBadge(false)"
                                    >
                                        {{ "badge_editor.send_badge" | translate }}
                                    </button>
                                    <!-- <button mat-button mat-dialog-close class="btn-feedbalia" [disabled]="checkValidData()" (click)="sendBadge(false)">
                          Entregar Medalla
                        </button> -->
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </mat-dialog-content>
}

<!-- ############## BADGE GRUPAL ############# -->
@if (badgeTab == 1) {
    <mat-dialog-content class="mat-typography">
        @if (!personsSelected.length > 0) {
            <div>
                <p class="m-0 mb-8">
                    <b>{{ "bagde_editor.select_user" | translate }}</b>
                </p>
                <div fxLayout="row wrap">
                    @for (person of personsSuggestion; track person) {
                        <div
                            fxFlex="50"
                            fxlayout="row"
                            fxLayoutAlign="flex-start center"
                            class="btn-select-person p-12"
                            (click)="selectPerson(person)"
                        >
                            <div class="person-avatar avatar-50 mr-8" fxLayout="row" fxLayoutAlign="center center">
                                <img
                                    class="img-circle"
                                    [src]="getImagePerson(person.username)"
                                    [title]="person.username"
                                />
                            </div>
                            <div fxLayout="column" class="info-person">
                                <h4 class="m-0 font-size-18 text-theme">{{ person.displayName }}</h4>
                                <small class="m-0 font-size-12">{{ getPuesto(person) }}</small>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
        @if (personsSelected.length > 0) {
            <div>
                @if (badgeStep === 1) {
                    <div fxLayout="row" fxLayoutAlign="space-between flex-start">
                        <mat-chip-listbox aria-label="Personas" class="chipPersonas">
                            @for (person of personsSelected; track person; let i = $index) {
                                <mat-chip-option
                                    [removable]="true"
                                    (removed)="unselectPersonArray(i)"
                                    class="personChip"
                                    [selectable]="false"
                                >
                                    <div fxLayout="row" class="gap-1" fxLayoutAlign="start center">
                                        <img
                                            class="img-circle imgChip"
                                            style="width: 30px !important"
                                            [src]="getImagePerson(person.username)"
                                            [title]="person.username"
                                        />
                                        <b class="text-truncate">{{ person.displayName }}</b>
                                    </div>
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                </mat-chip-option>
                            }
                        </mat-chip-listbox>
                        <div fxLayout="column" style="text-align: center">
                            <span class="m-0 font-size-14">{{ "badge_editor.select_competency" | translate }}</span>
                            <div
                                fxLayout="row wrap"
                                fxLayoutAlign="space-around center"
                                class="competency-list mt-8 px-20"
                            >
                                @for (competency of competencies.valores; track competency) {
                                    <div
                                        fxFlex="1 0 auto"
                                        fxLayoutAlign="center center"
                                        class="animated zoomIn"
                                        [title]="competency.name"
                                        (click)="selectCompetency(competency)"
                                    >
                                        <img [src]="getImageCompetency(competency.id)" class="competencyImage" />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                }
                @if (badgeStep === 3) {
                    <div fxLayoutAlign="middle flex-start" fxLayout="row" class="w-100-p">
                        <div fxLayout="column" class="chipPersonas">
                            @if (competencySelected && competencySelected.type_competency === 0) {
                                <img
                                    class="badge-selected animated zoomIn competencyImageEnd"
                                    [src]="getImageCompetency(competencySelected.id)"
                                    [title]="competencySelected.name"
                                />
                            }
                            <mat-chip-listbox aria-label="Personas">
                                @for (person of personsSelected; track person; let i = $index) {
                                    <mat-chip-option
                                        [removable]="true"
                                        (removed)="unselectPersonArray(i)"
                                        class="personChip"
                                        [selectable]="false"
                                    >
                                        <div fxLayout="row" class="gap-1" fxLayoutAlign="start center">
                                            <img
                                                class="img-circle imgChip"
                                                style="width: 30px !important"
                                                [src]="getImagePerson(person.username)"
                                                [title]="person.username"
                                            />
                                            <b class="text-truncate">{{ person.displayName }}</b>
                                        </div>
                                        <mat-icon matChipRemove>cancel</mat-icon>
                                    </mat-chip-option>
                                }
                            </mat-chip-listbox>
                        </div>
                        <div fxLayout="column" class="w-100-p">
                            <div class="animated fadeInRight">
                                <div class="mb-12">
                                    <div
                                        fxLayout="row"
                                        fxLayoutAlign="flex-start flex-start"
                                        style="cursor: pointer"
                                        (click)="badgeStep = 1; competencySelected = null; motivation = ''"
                                    >
                                        <mat-icon class="s-16 mr-4 pt-4 text-theme">arrow_back</mat-icon>
                                        <a class="m-0" style="color: #4f4d50">{{
                                            "badge_editor.competency.change" | translate
                                        }}</a>
                                    </div>
                                </div>
                                @if (competencySelected.type_competency === 0) {
                                    <div class="mb-16">
                                        <!-- Visible solo para comptencia de tipo Valor -->
                                        <span class="m-0 font-size-14">Indicadores</span>
                                        <div class="kpi-table">
                                            @for (indicator of indicators; track indicator) {
                                                <div class="my-8">
                                                    <input
                                                        id="badgeIndicator{{ indicator.id }}"
                                                        type="checkbox"
                                                        [(ngModel)]="indicator.isChecked"
                                                        (change)="calNumIndicatorSelected()"
                                                    />
                                                    <label for="badgeIndicator{{ indicator.id }}">{{
                                                        indicator.name
                                                    }}</label>
                                                </div>
                                            }
                                        </div>
                                        @if (minIndicators > 0 && minIndicators !== maxIndicators) {
                                            <span
                                                [style]="
                                                    minIndicators > numIndicatorsSelected ||
                                                    numIndicatorsSelected > maxIndicators
                                                        ? 'visibility:visible;'
                                                        : 'visibility:hidden;'
                                                "
                                                class="mt-12 font-size-14"
                                                style="color: red"
                                                >{{ "" | translate }}Debe seleccionar {{ minIndicators }} o
                                                {{ maxIndicators }} {{ "" | translate }}indicadores</span
                                            >
                                        }
                                        @if (minIndicators > 0 && minIndicators === maxIndicators) {
                                            <span
                                                [style]="
                                                    minIndicators > numIndicatorsSelected
                                                        ? 'visibility:visible;'
                                                        : 'visibility:hidden;'
                                                "
                                                class="mt-12 font-size-14"
                                                style="color: red"
                                                >{{ "" | translate }}Debe seleccionar al menos {{ minIndicators }}
                                                {{ "" | translate }}indicadores</span
                                            >
                                        }
                                    </div>
                                }
                            </div>
                            <div fxLayout="column">
                                <textarea
                                    class="form-control"
                                    [(ngModel)]="motivation"
                                    style="height: 60px"
                                    placeholder="¿Por qué le darás este agradecimiento?"
                                ></textarea>
                                <span
                                    [style]="
                                        motivation.length < minCharacters ? 'visibility:visible;' : 'visibility:hidden;'
                                    "
                                    class="text-muted"
                                    >{{ "" | translate }}Faltan {{ minCharacters - motivation.length }}
                                    {{ "" | translate }}caracteres</span
                                >
                            </div>
                            <div fxFlex="1 1 0" fxLayout="row" fxLayoutAlign="flex-end flex-end" class="mt-16">
                                <button
                                    mat-button
                                    mat-dialog-close
                                    class="btn-feedbalia"
                                    [disabled]="checkValidData()"
                                    (click)="sendBadge(false)"
                                >
                                    {{ "badge_editor.send_badge" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        }
    </mat-dialog-content>
}

<!-- ############## TANDEM ############# -->
@if (project.tandemMode) {
    <mat-dialog-content>
        @if (!personSelected) {
            <div>
                <div fxLayout="row wrap">
                    @for (person of personsTab | async; track person) {
                        <div
                            fxlayout="row"
                            fxLayoutAlign="start center"
                            class="btn-select-person p-12 gap-1"
                            (click)="selectPerson(person)"
                            style="width: 50%"
                        >
                            @if (person) {
                                <div class="person-avatar avatar-50 mr-8" fxLayout="row" fxLayoutAlign="center center">
                                    <img
                                        class="img-circle"
                                        [src]="getImagePerson(person.nickname)"
                                        [title]="person.nickname"
                                    />
                                </div>
                            }
                            @if (person) {
                                <div fxLayout="column" class="info-person">
                                    <h4 class="m-0 font-size-18 text-theme">{{ person.displayName }}</h4>
                                    <!-- <small class="m-0 font-size-12">{{getPuesto(person)}}</small> -->
                                </div>
                            }
                        </div>
                    }
                </div>
            </div>
        }
        @if (personSelected) {
            <div>
                <div class="badge-responsive-container" fxLayout="row">
                    <div
                        fxLayout="column"
                        fxLayoutAlign="flex-start center"
                        class="pr-20"
                        style="width: 32%; min-width: 140px"
                    >
                        <div class="person-avatar avatar-132" fxLayout="row" fxLayoutAlign="center center">
                            <img
                                class="img-circle"
                                [src]="getImagePersonGrande(personSelected.nickname)"
                                [title]="personSelected.nickname"
                            />
                            @if (!project.tandemMode) {
                                @if (competencySelected && competencySelected.type_competency === 0) {
                                    <img
                                        class="badge-selected animated zoomIn"
                                        [src]="getImageCompetency(competencySelected.id)"
                                        [title]="competencySelected.name"
                                    />
                                }
                                @if (competencySelected && competencySelected.type_competency !== 0) {
                                    <img
                                        class="badge-selected animated zoomIn"
                                        [src]="getImageDefaultMission()"
                                        [title]="competencySelected.name"
                                    />
                                }
                            }
                            @if (project.tandemMode) {
                                @if (competencySelected && competencySelected.image) {
                                    <img
                                        class="badge-selected animated zoomIn"
                                        [src]="getImageCompetency(competencySelected.id)"
                                        [title]="competencySelected.name"
                                    />
                                }
                            }
                        </div>
                        @if (project.badge_type) {
                            <div>
                                <h5 class="m-0 mb-8 mt-12 title-card-gray text-theme text-center">
                                    <b>{{ "bagde_editor.mission" | translate }}</b>
                                </h5>
                                <p class="m-0 font-size-14 text-center">{{ getMision(personSelected) }}</p>
                                @if (competencySelected) {
                                    <span>{{ competencySelected.name }}</span>
                                }
                            </div>
                        }
                    </div>
                    <div fxFlex="1 1 0" fxLayout="row" class="pl-20">
                        @if (badgeStep === 1 && !project.badge_type) {
                            <div class="competency-main" fxLayout="column">
                                <span class="m-0 font-size-14">{{
                                    "badge_editor.mission.value.title2" | translate
                                }}</span>
                                <div
                                    fxLayout="row wrap"
                                    fxLayoutAlign="space-around center"
                                    class="competency-list mt-8 px-20"
                                >
                                    @for (competency of competencies.valores; track competency) {
                                        <div
                                            fxFlex="1 0 auto"
                                            fxLayoutAlign="center center"
                                            class="animated zoomIn"
                                            [title]="competency.name"
                                            (click)="selectCompetency(competency)"
                                        >
                                            <img
                                                [src]="getImageCompetency(competency.id)"
                                                style="max-width: 50px; max-height: 50px"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        }
                        @if (project.badge_type) {
                            @if (badgeStep === 1) {
                                <div class="competency-main" fxLayout="column">
                                    <span class="m-0 font-size-14">{{ "badge_editor.mission.title" | translate }}</span>
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-between center"
                                        class="competency-list"
                                    >
                                        @for (competency of competencies.misionPuesto; track competency) {
                                            <div
                                                fxFlex="1 0 auto"
                                                class="mision-select mt-12 text-center animated zoomIn"
                                                [title]="competency.name"
                                                (click)="selectCompetency(competency)"
                                                style="width: 100%"
                                            >
                                                <span class="">{{ competency.name }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (competencies.misionEmpresa?.length || competencies.valores?.length) {
                                        <div class="mt-16">
                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="flex-start flex-start"
                                                style="cursor: pointer"
                                                (click)="badgeStep = 2"
                                            >
                                                <mat-icon class="s-16 mr-4 pt-4 text-theme">add_circle</mat-icon>
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.mission.other.title" | translate
                                                }}</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                            @if (badgeStep === 2) {
                                <div class="competency-extra" fxLayout="column">
                                    @if (competencies.misionEmpresa?.length) {
                                        <span class="m-0 font-size-14">{{
                                            "badge_editor.mission.company.title" | translate
                                        }}</span>
                                    }
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-between center"
                                        class="competency-list"
                                    >
                                        @for (competency of competencies.misionEmpresa; track competency) {
                                            <div
                                                fxFlex="1 0 auto"
                                                class="mision-select mt-12 text-center animated zoomIn"
                                                [title]="competency.name"
                                                (click)="selectCompetency(competency)"
                                                style="max-width: 120px"
                                            >
                                                <span class="">{{ competency.name }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (competencies.valores?.length) {
                                        <span class="m-0 font-size-14 mt-16">{{
                                            "badge_editor.mission.value.title" | translate
                                        }}</span>
                                    }
                                    <div
                                        fxLayout="row wrap"
                                        fxLayoutAlign="space-around center"
                                        class="competency-list mt-8 px-20"
                                    >
                                        @for (competency of competencies.valores; track competency) {
                                            <div
                                                fxFlex="1 0 auto"
                                                fxLayoutAlign="center center"
                                                class="animated zoomIn"
                                                [title]="competency.name"
                                                (click)="selectCompetency(competency)"
                                            >
                                                <img
                                                    [src]="getImageCompetency(competency.id)"
                                                    style="max-width: 50px; max-height: 50px"
                                                />
                                            </div>
                                        }
                                    </div>
                                    @if (project.id != 10 && project.id != 4) {
                                        <div class="mt-12">
                                            <div
                                                fxLayout="row"
                                                fxLayoutAlign="flex-start flex-start"
                                                style="cursor: pointer"
                                                (click)="badgeStep = 1"
                                            >
                                                <mat-icon class="s-16 mr-4 pt-4 text-theme">arrow_back</mat-icon>
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.change_competency" | translate
                                                }}</a>
                                            </div>
                                        </div>
                                    }
                                </div>
                            }
                        }
                        @if (badgeStep === 3) {
                            <div fxLayout="column" class="w-100-p">
                                <div class="animated fadeInRight">
                                    <div class="mb-12">
                                        <div
                                            fxLayout="row"
                                            fxLayoutAlign="flex-start flex-start"
                                            style="cursor: pointer"
                                            (click)="badgeStep = 1; competencySelected = null; motivation = ''"
                                        >
                                            <mat-icon class="s-16 mr-4 pt-4 text-theme">arrow_back</mat-icon>
                                            @if (project.badge_type) {
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.change_competency" | translate
                                                }}</a>
                                            }
                                            @if (!project.badge_type) {
                                                <a class="m-0" style="color: #4f4d50">{{
                                                    "badge_editor.mission.back" | translate
                                                }}</a>
                                            }
                                        </div>
                                        @if (project.tandemMode) {
                                            <div fxLayout="row" fxLayoutAlign="flex-start flex-start">
                                                <span class="m-0 font-size-14">{{
                                                    competencySelected.description
                                                }}</span>
                                            </div>
                                        }
                                    </div>
                                    @if (competencySelected.type_competency === 0 || project.id == 288) {
                                        <div class="mb-16">
                                            <!-- Visible solo para comptencia de tipo Valor -->
                                            <span class="m-0 font-size-14">{{
                                                competencySelected.type_competency === 0
                                                    ? "Indicadores"
                                                    : "Comportamientos"
                                            }}</span>
                                            <div class="kpi-table">
                                                @for (indicator of indicators; track indicator) {
                                                    <div class="my-8">
                                                        <input
                                                            id="badgeIndicator{{ indicator.id }}"
                                                            type="checkbox"
                                                            [(ngModel)]="indicator.isChecked"
                                                            (change)="calNumIndicatorSelected()"
                                                        />
                                                        <label for="badgeIndicator{{ indicator.id }}">{{
                                                            indicator.name
                                                        }}</label>
                                                    </div>
                                                }
                                            </div>
                                            @if (minIndicators > 0 && minIndicators !== maxIndicators) {
                                                <span
                                                    [style]="
                                                        minIndicators > numIndicatorsSelected ||
                                                        numIndicatorsSelected > maxIndicators
                                                            ? 'visibility:visible;'
                                                            : 'visibility:hidden;'
                                                    "
                                                    class="mt-12 font-size-14"
                                                    style="color: red"
                                                    >Debe seleccionar {{ minIndicators }} o {{ maxIndicators }}
                                                    {{
                                                        competencySelected.type_competency === 0
                                                            ? "indicadores"
                                                            : "comportamientos"
                                                    }}</span
                                                >
                                            }
                                            @if (minIndicators > 0 && minIndicators === maxIndicators) {
                                                <span
                                                    [style]="
                                                        minIndicators > numIndicatorsSelected ||
                                                        numIndicatorsSelected > maxIndicators
                                                            ? 'visibility:visible;'
                                                            : 'visibility:hidden;'
                                                    "
                                                    class="mt-12 font-size-14"
                                                    style="color: red"
                                                    >Debe seleccionar únicamente {{ minIndicators }}
                                                    {{
                                                        competencySelected.type_competency === 0
                                                            ? "indicadores"
                                                            : "comportamientos"
                                                    }}</span
                                                >
                                            }
                                        </div>
                                    }
                                </div>
                                <div fxLayout="row" fxLayoutAlign="flex-start" class="w-100-p">
                                    <fb-emoji-picker
                                        position="fixed"
                                        (emojiSel)="emojiSelected($event)"
                                    ></fb-emoji-picker>
                                    <div fxLayout="column" class="w-100-p">
                                        <textarea
                                            class="form-control w-100-p"
                                            [(ngModel)]="motivation"
                                            style="height: 60px"
                                            placeholder="{{ 'badge_editor.motive.placeholder' | translate }}"
                                        ></textarea>
                                        <span
                                            [style]="
                                                motivation.length < minCharacters
                                                    ? 'visibility:visible;'
                                                    : 'visibility:hidden;'
                                            "
                                            class="text-muted"
                                            >{{ "" | translate }}Faltan {{ minCharacters - motivation.length }}
                                            {{ "" | translate }}caracteres</span
                                        >
                                    </div>
                                </div>
                                <div fxFlex="1 1 0" fxLayout="row" fxLayoutAlign="flex-end flex-end" class="mt-16">
                                    <button
                                        mat-button
                                        mat-dialog-close
                                        class="btn-feedbalia"
                                        [disabled]="checkValidData()"
                                        (click)="sendBadge(false)"
                                    >
                                        {{ "badge_editor.send_badge" | translate }}
                                    </button>
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </mat-dialog-content>
}
